import React from 'react';
import { Box, Typography, Button, Tooltip } from '@mui/material';
import { SwapHoriz, Undo } from '@mui/icons-material';
import { useAuthContext } from 'Shared/Security/Domain/Contexts/authContext';

export default function ImpersonationBanner() {
  const { isImpersonating, revertImpersonation, getMeFromLocalStorage, getOriginalAdminFromLocalStorage } = useAuthContext();

  if (!isImpersonating) {
    return null;
  }

  const currentUser = getMeFromLocalStorage();
  const originalAdmin = getOriginalAdminFromLocalStorage();

  const currentDisplayName = currentUser 
    ? `${currentUser.name || ''} ${currentUser.firstSurname || ''}`.trim() || currentUser.email 
    : 'Usuario';

  return (
    <Box
      sx={{
        width: '100%',
        height: '38px',
        minHeight: '38px',
        maxHeight: '38px',
        bgcolor: '#0f172a',
        borderBottom: '2px solid #f59e0b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: { xs: 1.5, sm: 2.5 },
        boxSizing: 'border-box',
        zIndex: 1400,
        flexShrink: 0,
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', minWidth: 0, overflow: 'hidden', mr: 2 }}>
        <SwapHoriz sx={{ color: '#f59e0b', fontSize: 20, mr: 1, flexShrink: 0 }} />
        <Typography
          variant="body2"
          sx={{
            color: '#e2e8f0',
            fontSize: { xs: '0.75rem', sm: '0.82rem' },
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          <Box component="span" sx={{ display: { xs: 'none', md: 'inline' }, opacity: 0.85, mr: 0.5 }}>
            Modo suplantación &bull;
          </Box>
          Sesión como: <strong style={{ color: '#fbbf24' }}>{currentDisplayName}</strong>
          {currentUser?.email && (
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline' }, opacity: 0.7, ml: 0.5 }}>
              ({currentUser.email})
            </Box>
          )}
        </Typography>
      </Box>

      <Tooltip title={originalAdmin ? `Volver a la sesión de ${originalAdmin.email}` : 'Volver a tu cuenta de administrador'}>
        <Button
          variant="contained"
          size="small"
          startIcon={<Undo sx={{ fontSize: '1rem !important' }} />}
          onClick={revertImpersonation}
          sx={{
            bgcolor: '#f59e0b',
            color: '#0f172a',
            fontWeight: 800,
            fontSize: { xs: '0.72rem', sm: '0.78rem' },
            textTransform: 'none',
            borderRadius: '4px',
            px: { xs: 1.2, sm: 1.8 },
            py: 0.2,
            minHeight: '26px',
            whiteSpace: 'nowrap',
            flexShrink: 0,
            boxShadow: 'none',
            '&:hover': {
              bgcolor: '#d97706',
              color: '#ffffff',
              boxShadow: 'none',
            }
          }}
        >
          Volver usuario original
        </Button>
      </Tooltip>
    </Box>
  );
}
